import { Component, Prop, Vue } from "vue-property-decorator";

// Helpers
import { getEmptyProductImageUrl } from "@/plugins/products_helper";

@Component({})
export default class IngredientCard extends Vue {
  @Prop({ default: null }) ingredient;

  get ingredientImageUrl() {
    const { img } = this.ingredient;
    if (!img || !img.url) return getEmptyProductImageUrl();
    return img.url;
  }
}
